// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@pace/Overrides/Components/CartLineCardExpanded";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.subtotalWithoutVatText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
cartLineCardExpandedStyles.vatAmount = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
cartLineCardExpandedStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.configurationOptionText = {
    css: css`
        display: block;
    `,
};

cartLineCardExpandedStyles.configurationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.costCodeValueText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.nonStockInventoryMessage = {
    size: 12,
    weight: fontConfig.weight.bold,
    forwardAs: "p",
    lineHeight: "12px",
};